import { Product } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';

const AllowedProducts: Product[] = [Product.CONSUMER_LOAN, Product.CREDIT_LINE, Product.AUTO, Product.CARD];

export const AllowedProductsOptions = AllowedProducts.map((value) => ({
  value,
  display: <Text tId={value} />,
}));
